import type {
  ClassProgressSuggestionItem,
  DashboardDetailResponse,
  DashboardSummaryResponse,
  EasyLearning,
  ListenNReadResponse,
  PointCardContent,
  RecordSubjectResponse,
  TotalListenNReadResponse,
  TotalRecordSubjectResponse
} from '@/models/interface/learningProgress';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class LearningProgressService extends ApiFactory {
  constructor() {
    super('LearningMap');
  }

  easyLearning(): Promise<ApiDataResponse<EasyLearning>> {
    return super.get(`EasyLearning`);
  }

  totalEasyLearning(): Promise<ApiDataResponse<EasyLearning>> {
    return super.get(`TotalEasyLearning`);
  }

  listenNRead(): Promise<ApiDataResponse<ListenNReadResponse>> {
    return super.get(`ListenNRead`);
  }

  totalListenNRead(): Promise<ApiDataResponse<TotalListenNReadResponse>> {
    return super.get(`TotalListenNRead`);
  }

  requiredSubject(): Promise<ApiDataResponse<RecordSubjectResponse>> {
    return super.get(`RequiredSubject`);
  }

  totalRequiredSubject(): Promise<ApiDataResponse<TotalRecordSubjectResponse>> {
    return super.get(`TotalRequiredSubject`);
  }

  electiveSubject(): Promise<ApiDataResponse<RecordSubjectResponse>> {
    return super.get(`ElectiveSubject`);
  }

  totalElectiveSubject(): Promise<ApiDataResponse<TotalRecordSubjectResponse>> {
    return super.get(`TotalElectiveSubject`);
  }

  /**
   * 取得 學習進度目標計數資料
   */
  getDashboardSummary(): Promise<ApiDataResponse<DashboardSummaryResponse>> {
    return super.get(`GetDashboardSummary`);
  }

  /**
   * 取得 學習進度儀錶板詳細內容
   */
  getDashboard(): Promise<ApiDataResponse<DashboardDetailResponse>> {
    return super.get(`GetDashboard`);
  }

  /**
   * 依儀錶板項目 key 取得集點卡／戳章歷程與規則說明
   * @param key - 同 GetDashboard items：1 輕鬆學、3 精讀、4 必修、5 選修
   */
  getPointCard(key: number): Promise<ApiDataResponse<PointCardContent>> {
    return super.get(`GetPointCard`, { key });
  }

  /**
   * 依儀錶板項目 key 取得課程進度建議清單（表格用）
   * @param key - 同 GetDashboard items：1 輕鬆學、3 精讀、4 必修、5 選修
   */
  getClassProgressSuggestion(
    key: number
  ): Promise<ApiDataResponse<ClassProgressSuggestionItem[]>> {
    return super.get(`ClassProgressSuggestion`, { key });
  }
}
